import { Country } from '../constants'

const codeToCountryMap: Record<string, Country> = {
  USA: Country.US,
  US: Country.US,
  CH: Country.CH,
  CHE: Country.CH,
  DE: Country.DE,
  DEU: Country.DE,
}

const codeToCountry = (code = ''): Country => {
  const cleanedCode = code.toUpperCase().trim()
  return codeToCountryMap[cleanedCode] ?? Country.US
}

export { codeToCountry }
